<template>
    <div class="container">
        <div v-if="loading" class="d-flex justify-content-center align-items-center p-5">
            <div class="spinner-border text-dark m-5 p-3" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div class="" v-else>
            <ul class="nav project-nav-tabs row d-flex">
                <li class="nav-item col" data-aos="zoom-in">
                    <a class="nav-link active show" data-bs-toggle="tab" href="#project-tab-1">
                        <i class="ri-gps-line d-none"></i>
                        <h4 class="p-3">{{projects[0].title}}</h4>
                    </a>
                </li>
                <li class="nav-item col" data-aos="zoom-in" data-aos-delay="100">
                    <a class="nav-link" data-bs-toggle="tab" href="#project-tab-2">
                        <i class="ri-store-line d-none"></i>
                        <h4 class="p-3">{{projects[1].title}}</h4>
                    </a>
                </li>
                <li class="nav-item col" data-aos="zoom-in" data-aos-delay="100">
                    <a class="nav-link" data-bs-toggle="tab" href="#project-tab-3">
                        <i class="ri-store-line d-none"></i>
                        <h4 class="p-3">{{projects[2].title}}</h4>
                    </a>
                </li>
            </ul>

            <div class="tab-content" data-aos="fade-up">
                <div class="tab-pane active show" id="project-tab-1">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                            <h3>{{projects[0].title}}</h3>
                            <p class="fst-italic">
                                <span>{{projects[0].subtitle}}</span>
                            </p>
                            <p>
                                {{projects[0].descriptionOne}}
                            </p>
                            <p>
                                {{projects[0].descriptionTwo}}
                            </p>
                            <div class="mt-4">
                                <h5>Benefits</h5>
                            </div>
                            <p>
                                {{projects[0].beneficiaries}}
                            </p>
                            <div class="mt-4">
                                <h5>Project Requirements</h5>
                            </div>
                            <ul v-for="(item, i) in projects[0].requirement" :key="i">
                                <li><i class="ri-check-double-line"></i>{{item}}</li>
                            </ul>
                            <div class="d-flex gap-4 align-items-center">
                                <div>
                                    <a :href="projects[0].link" target="blank" class="btn-visit text-center">More About FILMA</a>
                                </div>
                                <div>
                                    <button class="btn-form btn btn-primary" data-bs-toggle="modal" data-bs-target="#filmaModal" type="button">Apply Here</button>
                                </div>
                                
                                <!-- <a href="https://play.google.com/store/apps/details?id=com.agroinnova.farmerbusinessschool2" target="blank">
                                    <img class="btn-download" src="../../assets/img/playstore.png" alt="download"/>
                                </a> -->
                            </div>
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                            <img :src="projects[0].image" class="img-fluid rounded w-75" />
                        </div>
                    </div>
                </div>

                <div class="tab-pane" id="project-tab-2">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                            <h3>{{projects[1].title}}</h3>
                            <p class="fst-italic">
                                <span>{{projects[1].subtitle}}</span>
                            </p>
                            <p>
                                {{projects[1].descriptionOne}}
                            </p>
                            <p>
                                {{projects[1].descriptionTwo}}
                            </p>
                            <div class="mt-4">
                                <h5>Benefits</h5>
                            </div>
                            <p>
                                {{projects[1].beneficiaries}}
                            </p>
                            <div class="mt-4">
                                <h5>Project Requirements</h5>
                            </div>
                            <ul v-for="(item, i) in projects[1].requirement" :key="i">
                                <li><i class="ri-check-double-line"></i>{{item}}</li>
                            </ul>
                            <div class="d-flex gap-4 align-items-center">
                                <!-- <p><strong>Coming Soon</strong></p> -->
                                <a :href="projects[1].link" target="blank" class="btn-visit text-center">More About PIAA</a>
                                <div>
                                    <button class="btn-form btn btn-primary" data-bs-toggle="modal" data-bs-target="#piaaModal" type="button">Apply Here</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                            <img :src="projects[1].image" class="img-fluid rounded w-75" />
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="project-tab-3">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                            <h3>{{projects[2].title}}</h3>
                            <p class="fst-italic">
                                <span>{{projects[2].subtitle}}</span>
                            </p>
                            <p>
                                {{projects[2].descriptionOne}}
                            </p>
                            <p>
                                {{projects[2].descriptionTwo}}
                            </p>
                            <div class="mt-4">
                                <h5>Benefits</h5>
                            </div>
                            <p>
                                {{projects[2].beneficiaries}}
                            </p>
                            <div class="mt-4">
                                <h5>Project Requirements</h5>
                            </div>
                            <ul v-for="(item, i) in projects[2].requirement" :key="i">
                                <li><i class="ri-check-double-line"></i>{{item}}</li>
                            </ul>
                            <div class="d-flex gap-4 align-items-center">
                                <!-- <p><strong>Coming Soon</strong></p> -->
                                <a :href="projects[2].link" target="blank" class="btn-visit text-center">More About BIA</a>
                                <div>
                                    <button class="btn-form btn btn-primary" data-bs-toggle="modal" data-bs-target="#biaModal" type="button">Apply Here</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                            <img :src="projects[2].image" class="img-fluid rounded w-75" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FILMA Registration Modal -->
        <div class="modal fade" id="filmaModal" tabindex="-1" aria-labelledby="filmaModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="filmaModalLabel">FILMA Registration Form</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="w-100 mb-3 text-start">
                        <small class="text-muted">Please fill in the form below to apply for the FILMA - Poultry Success Initiative. Ensure that all information provided is accurate and complete.</small>
                    </div>
                    <form @submit.prevent="submitForm">
                        <div class="row w-100">
                            <div class="text-start mb-2">
                                <strong>Personal Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="filmaData.client_name" type="text" class="form-control" id="clientName" placeholder="Name" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="filmaData.client_phone" type="text" class="form-control" id="clientPhone" placeholder="Phone"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="filmaData.client_location" type="text" class="form-control" id="clientLocation" placeholder="Location / Digital Address"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="filmaData.region">
                                    <option selected disabled value="">Select Region</option>
                                    <option v-for="(region, i) in regionsFilma" :key="i" :value="region">{{region}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="filmaData.district" type="text" class="form-control" id="district" placeholder="District"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="filmaData.community" type="text" class="form-control" id="community" placeholder="Community"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="filmaData.age" type="text" class="form-control" id="age" placeholder="Age"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="filmaData.sex">
                                    <option selected disabled value="">Select Sex</option>
                                    <option v-for="(sex, i) in sexes" :key="i" :value="sex">{{sex}}</option>
                                </select>
                            </div>
                            <div class="text-start mb-2">
                                <strong>Package Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="filmaData.ghana_card" type="text" class="form-control" id="ghanaCard" placeholder="Ghana Card Number"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="filmaData.category.item">
                                    <option selected disabled value="">Select Farm Type</option>
                                    <option v-for="(category, i) in productCategories" :key="i" :value="category">{{category.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must first select a farm type</em></small>
                                <select class="form-select" aria-label="Default select example" v-model="filmaData.confirmed">
                                    <option selected disabled value="">Select Payment Means</option>
                                    <option v-for="(paymentMean, i) in filmaPaymentMeansOptions" :key="i" :value="paymentMean">{{paymentMean}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must select a farm type before selecting a package</em></small>
                                <select :disabled="!filmaData.category.item" class="form-select" aria-label="Default select example" v-model="filmaData.product.item">
                                    <option selected disabled value="">Select Package</option>
                                    <option v-for="(product, i) in filmaPackageOptions" :key="i" :value="product">{{product.name}}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-success" @click="submitFilmaForm">Submit</button>
                </div>
                </div>
            </div>
        </div>

        <!-- PIAA Registration Modal -->
        <div class="modal fade" id="piaaModal" tabindex="-1" aria-labelledby="piaaModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="piaaModalLabel">PIAA Registration Form</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="w-100 mb-3 text-start">
                        <small class="text-muted">Please fill in the form below to apply for the PIAA - Poultry Farm to Fork Initiative. Ensure that all information provided is accurate and complete.</small>
                    </div>
                    <form @submit.prevent="submitForm">
                        <div class="row w-100">
                            <div class="text-start mb-2">
                                <strong>Personal Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="piaaData.client_name" type="text" class="form-control" id="clientName" placeholder="Name" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="piaaData.client_phone" type="text" class="form-control" id="clientPhone" placeholder="Phone"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="piaaData.client_location" type="text" class="form-control" id="clientLocation" placeholder="Location / Digital Address"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="piaaData.region">
                                    <option selected disabled value="">Select Region</option>
                                    <option v-for="(region, i) in regionsPiaa" :key="i" :value="region">{{region}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="piaaData.district" type="text" class="form-control" id="district" placeholder="District"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="piaaData.community" type="text" class="form-control" id="community" placeholder="Community"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="piaaData.age" type="text" class="form-control" id="age" placeholder="Age"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="piaaData.sex">
                                    <option selected disabled value="">Select Sex</option>
                                    <option v-for="(sex, i) in sexes" :key="i" :value="sex">{{sex}}</option>
                                </select>
                            </div>
                            <div class="text-start mb-2">
                                <strong>Package Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="piaaData.ghana_card" type="text" class="form-control" id="ghanaCard" placeholder="Ghana Card Number"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="piaaData.category.item">
                                    <option selected disabled value="">Select Farm Type</option>
                                    <option v-for="(category, i) in productCategories" :key="i" :value="category">{{category.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must first select a farm type</em></small>
                                <select class="form-select" aria-label="Default select example" v-model="piaaData.confirmed">
                                    <option selected disabled value="">Select Payment Means</option>
                                    <option v-for="(paymentMean, i) in piaaPaymentMeansOptions" :key="i" :value="paymentMean">{{paymentMean}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must select a farm type before selecting a package</em></small>
                                <select :disabled="!piaaData.category.item" class="form-select" aria-label="Default select example" v-model="piaaData.product.item">
                                    <option selected disabled value="">Select Package</option>
                                    <option v-for="(product, i) in piaaPackageOptions" :key="i" :value="product">{{product.name}}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-success" @click="submitPiaaForm">Submit</button>
                </div>
                </div>
            </div>
        </div>

        <!-- BIA Registration Modal -->
        <div class="modal fade" id="biaModal" tabindex="-1" aria-labelledby="biaModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="biaModalLabel">BIA Registration Form</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="w-100 mb-3 text-start">
                        <small class="text-muted">Please fill in the form below to apply for the BIA - Agro Innova Poultry and Grains Project. Ensure that all information provided is accurate and complete.</small>
                    </div>
                    <form @submit.prevent="submitForm">
                        <div class="row w-100">
                            <div class="text-start mb-2">
                                <strong>Personal Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="biaData.client_name" type="text" class="form-control" id="clientName" placeholder="Name" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required  v-model="biaData.client_phone" type="text" class="form-control" id="clientPhone" placeholder="Phone"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="biaData.client_location" type="text" class="form-control" id="clientLocation" placeholder="Location / Digital Address"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="biaData.region">
                                    <option selected disabled value="">Select Region</option>
                                    <option v-for="(region, i) in regionsPiaa" :key="i" :value="region">{{region}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="biaData.district" type="text" class="form-control" id="district" placeholder="District"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="biaData.community" type="text" class="form-control" id="community" placeholder="Community"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="biaData.age" type="text" class="form-control" id="age" placeholder="Age"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="biaData.sex">
                                    <option selected disabled value="">Select Sex</option>
                                    <option v-for="(sex, i) in sexes" :key="i" :value="sex">{{sex}}</option>
                                </select>
                            </div>
                            <div class="text-start mb-2">
                                <strong>Package Information</strong>
                            </div>
                            <div class="col-md-6 mb-3">
                                <input required v-model="biaData.ghana_card" type="text" class="form-control" id="ghanaCard" placeholder="Ghana Card Number"/>
                            </div>
                            <div class="col-md-6 mb-3">
                                <select class="form-select" aria-label="Default select example" v-model="biaData.category.item">
                                    <option selected disabled value="">Select Farm Type</option>
                                    <option v-for="(category, i) in productCategories" :key="i" :value="category">{{category.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must first select a farm type</em></small>
                                <select class="form-select" aria-label="Default select example" v-model="biaData.confirmed">
                                    <option selected disabled value="">Select Payment Means</option>
                                    <option v-for="(paymentMean, i) in biaPaymentMeansOptions" :key="i" :value="paymentMean">{{paymentMean}}</option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-3 text-start">
                                <small class="text-muted"><em>You must select a farm type before selecting a package</em></small>
                                <select :disabled="!biaData.category.item" class="form-select" aria-label="Default select example" v-model="biaData.product.item">
                                    <option selected disabled value="">Select Package</option>
                                    <option v-for="(product, i) in biaPackageOptions" :key="i" :value="product">{{product.name}}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-success" @click="submitBiaForm">Submit</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { productEndpoint } from "@/endpoint/endpoint"
import config from "../../../firebase.config"

// Firebase initialization
import {initializeApp} from 'firebase/app'
import { getFirestore, collection, setDoc, getDocs, where, query, doc, orderBy } from 'firebase/firestore/lite';

const configOptions = config.firebase;
const firebaseApp = initializeApp(configOptions);
const db = getFirestore(firebaseApp);

const projectArray = [
    {
        title: "FILMA - Poultry Success Initiative",
        subtitle: "FILMA - Financial Inclusion for Last Mile Actors",
        descriptionOne: "FILMA Ghana in partnership with Agro Innova Co. Ltd. is supporting over 10,000 youth and women engaged in the poultry and grain value chains across the Volta, Oti, and Northern Regions of Ghana.",
        descriptionTwo: "The initiative seeks to empower beneficiaries through sustainable agricultural support and economic opportunities within the poultry and grain sectors, particularly in maize and soybean production.",
        beneficiaries: "Under this programme, beneficiaries will receive input financing support packages, including: Day-Old Chicks, Poultry Feed, Medications and Vaccines, Maize and Soybean Seeds, Fertiliser and Other Farm Inputs. In addition, beneficiaries will benefit from: Practical training and capacity-building programmes, Technical support and mentorship, Access to ready and reliable markets for their farm produce",
        requirement: ["Must be a female between the ages of 15 and 35 years",
         "Must possess a valid Ghana Card", 
         "Must reside within the Volta, Oti, or Northern Region of Ghana", 
         "Must operate a farm within any of the following districts: South Tongu, North Tongu, Ketu North, Hohoe, Jasikan, Kadjebi, Nkwanta North, Nkwanta South and Gushegu"],
        image: "https://res.cloudinary.com/dp9w9miha/image/upload/v1776788302/A5_Flyer_UPDATE_ed1a13fc41.jpg?updated_at=2026-04-21T16:18:26.205Z",
        link: "https://www.filmaghana.com/",
    },
    {
        title: "PIAA - Poultry Farm to Fork Initiative",
        subtitle: "PIAA - Presidential Initiative In Agriculture and Agribusiness",
        descriptionOne: "The Poultry Farm-to-Fork Initiative is being implemented by the Ghana's Presidential Initiative in Agriculture and Agribusiness in partnership with Agro Innova Co. Ltd., with the primary objective of creating sustainable employment opportunities for the youth within the poultry value chain.",
        descriptionTwo: "The initiative aims to target over 500,000 Ghanaians across all 16 regions of the country by providing employment opportunities along the entire poultry value chain — from production to processing, distribution, and marketing.",
        beneficiaries: "As part of the programme, beneficiaries will receive comprehensive input financing support packages, including:Day-Old Chicks Poultry Feed, Medications and Vaccines, Feeders and Drinkers. In addition, all beneficiaries will receive: Capacity-building and practical training, Technical support and mentorship,Access to ready and reliable markets for their poultry products",
        requirement: ["Must be a Ghanaian citizen aged 18 years or above", "Must have a valid Ghana Card", "Must satisfy all other applicable terms and conditions of the programme"],
        image: "https://res.cloudinary.com/dp9w9miha/image/upload/v1776792256/A2_Flyer_PIAA_2_2c86003977.jpg?updated_at=2026-04-21T17:24:18.480Z",
        link: "https://piaa.gov.gh/",
    },
    {
        title: "BIA - Agro Innova Poultry and Grains Project",
        subtitle: "BIA - Bridge In Agriculture",
        descriptionOne: "Agro Innova Co. Ltd., in partnership with First National Bank Ghana and BRIDGE-in Agriculture (BIA) by CrossBoundary, is supporting over 10,000 youth and women engaged in the poultry and grain value chains across the Northern and Southern Regions of Ghana.",
        descriptionTwo: "The initiative is designed to promote sustainable agricultural development, youth empowerment, and economic inclusion by providing access to essential farming inputs, technical support, and market opportunities within the poultry and grain sectors, particularly maize and soybean production.",
        beneficiaries: "Under this programme, beneficiaries will receive input financing support packages, including: Day-Old Chicks, Poultry Feed, Medications and Vaccines,Maize and Soybean Seeds, Fertiliser and Other Farm Inputs. In addition, beneficiaries will benefit from: Practical training and capacity-building programmes, Technical support and mentorship, Access to ready and reliable markets for their farm produce",
        requirement: ["Must be a female between the ages of 15 and 35 years", "Must have a valid Ghana Card", "Must satisfy all other applicable terms and conditions of the programme"],
        image: "https://res.cloudinary.com/dp9w9miha/image/upload/v1780399152/BIA_3c2bd8515f.jpg?updated_at=2026-06-02T11:19:14.184Z",
        link: "https://bridgeinagric.com/",
    }
];

const categoriesRef = collection(db, "categories");
const q = query(categoriesRef, where("service", "==", "omLbBioUs9mtKcRFe7vD"), orderBy("index", "asc"));

const productRef = collection(db, "products");
const p = query(productRef);

export default {
    name: "Projects",

    data() {
        return {
            projects: [],
            loading: true,
            productCategories: [],
            projectProducts:[],
            packageOptions: [],
            filmaData: {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",
                sex: "",
                ghana_card: "",
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "FILMA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application",
            },
            piaaData: {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",
                sex: "",
                ghana_card: "",
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "PIAA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application",
            },
            biaData: {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",
                sex: "",
                ghana_card: "",
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "BIA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application",
            },
            regionsFilma: [
                'Volta',
                'Oti',
                'Northern'
            ],
            regionsPiaa: [
                'Ahafo',
                'Ashanti',
                'Bono',
                'Bono East',
                'Brong Ahafo',
                'Central',
                'Eastern',
                'Greater Accra',
                'Northern',
                'North East',
                'Oti',
                'Savannah',
                'Upper East',
                'Upper West',
                'Volta',
                'Western'
            ],
            sexes: [
                'Male',
                'Female',
            ],
            payments: ["Cash", "Transfer"],
        }
    },
    computed:{
        filmaPackageOptions() {
            const selectedCategory = this.productCategories.find(category => category.name === this.filmaData.category.item?.name);
            // console.log(selectedCategory, "-------selected category");
            // console.log(this.filmaData.category.item.name, "-------selected category name");
            getDocs(
                p
            ).then((querySnapshot) => {
                const products = [];
                querySnapshot.forEach((doc) => {
                    products.push({ id: doc.id, ...doc.data() });
                });
                this.projectProducts = products;
                // console.log(this.projectProducts, "-------products");
                const pkgs = this.projectProducts.filter(product => product.category === selectedCategory.id);
                this.packageOptions = pkgs;
            }).catch((error) => {
                console.error("Error fetching products: ", error);
            }
            )
            return this.packageOptions;
            
        },
        piaaPackageOptions() {
            const selectedCategory = this.productCategories.find(category => category.name === this.piaaData.category.item?.name);
            // console.log(selectedCategory, "-------selected category");
            // console.log(this.piaaData.category.item.name, "-------selected category name");
            getDocs(
                p
            ).then((querySnapshot) => {
                const products = [];
                querySnapshot.forEach((doc) => {
                    products.push({ id: doc.id, ...doc.data() });
                });
                this.projectProducts = products;
                // console.log(this.projectProducts, "-------products");
                const pkgs = this.projectProducts.filter(product => product.category === selectedCategory.id);
                this.packageOptions = pkgs;
            }).catch((error) => {
                console.error("Error fetching products: ", error);
            }
            )
            return this.packageOptions;
            
        },
        biaPackageOptions() {
            const selectedCategory = this.productCategories.find(category => category.name === this.biaData.category.item?.name);
            // console.log(selectedCategory, "-------selected category");
            // console.log(this.biaData.category.item.name, "-------selected category name");
            getDocs(
                p
            ).then((querySnapshot) => {
                const products = [];
                querySnapshot.forEach((doc) => {
                    products.push({ id: doc.id, ...doc.data() });
                });
                this.projectProducts = products;
                // console.log(this.projectProducts, "-------products");
                const pkgs = this.projectProducts.filter(product => product.category === selectedCategory.id);
                this.packageOptions = pkgs;
            }).catch((error) => {
                console.error("Error fetching products: ", error);
            }
            )
            return this.packageOptions;
            
        },
        filmaPaymentMeansOptions() {
            let farmItem = this.filmaData.category.item.name?.split(" ")[0];
            console.log(farmItem, "-------selected farm item");
            const selectedPaymentMeans = () => {
                switch(farmItem) {
                    case "Broiler":
                        return ["With Cash", "With Broilers"];
                    case "Layer":
                        return ["With Cash", "With Layers"];
                    case "Maize":
                        return ["With Cash", "With Maize"];
                    case "Soya":
                        return ["With Cash", "With Soybeans"];
                    default:
                        return [];
                }
            }
            
            return selectedPaymentMeans();
        },
        piaaPaymentMeansOptions() {
            let farmItem = this.piaaData.category.item.name?.split(" ")[0];
            console.log(farmItem, "-------selected farm item");
            const selectedPaymentMeans = () => {
                switch(farmItem) {
                    case "Broiler":
                        return ["With Cash", "With Broilers"];
                    case "Layer":
                        return ["With Cash", "With Layers"];
                    case "Maize":
                        return ["With Cash", "With Maize"];
                    case "Soya":
                        return ["With Cash", "With Soybeans"];
                    default:
                        return [];
                }
            }
            
            return selectedPaymentMeans();
        },
        biaPaymentMeansOptions() {
            let farmItem = this.biaData.category.item.name?.split(" ")[0];
            console.log(farmItem, "-------selected farm item");
            const selectedPaymentMeans = () => {
                switch(farmItem) {
                    case "Broiler":
                        return ["With Cash", "With Broilers"];
                    case "Layer":
                        return ["With Cash", "With Layers"];
                    case "Maize":
                        return ["With Cash", "With Maize"];
                    case "Soya":
                        return ["With Cash", "With Soybeans"];
                    default:
                        return [];
                }
            }
            
            return selectedPaymentMeans();
        }                
    },

    mounted(){
        this.fetchProjects(),

        getDocs(
            q
        ).then((querySnapshot) => {
            const categories = [];
            querySnapshot.forEach((doc) => {
                categories.push({ id: doc.id, ...doc.data() });
            });
            this.productCategories = categories;
            // console.log(this.productCategories, "-------categories");
        }).catch((error) => {
            console.error("Error fetching categories: ", error);
        })
    },

    methods: {
        fetchProjects() {
            setTimeout(() => {
                this.projects = projectArray;
                this.loading = false
                // console.log(this.projects, "--------projects");
            }, 2000)
        },

        validateFilmaForm() {
            for (const key in this.filmaData) {
            if (this.filmaData.hasOwnProperty(key) && this.filmaData[key] === "") {
                return false;
            }
            }
            return true;
        },
        validatePiaaForm() {
            for (const key in this.piaaData) {
            if (this.piaaData.hasOwnProperty(key) && this.piaaData[key] === "") {
                return false;
            }
            }
            return true;
        },
        validateBiaForm() {
            for (const key in this.biaData) {
            if (this.biaData.hasOwnProperty(key) && this.biaData[key] === "") {
                return false;
            }
            }
            return true;
        },
        submitFilmaForm(e) {
            e.preventDefault();
            if (!this.validateFilmaForm()) {
                // Display an error message or show a validation error
                alert("Please fill in all fields.");
                return;
            }
            // Logic to submit the form data
            this.submissionUtils(this.filmaData);
            alert("FILMA Form submitted successfully!");
            // Reset form fields after submission
            this.filmaData = {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",                
                sex: "",
                ghana_card: "", 
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "FILMA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application",
            };
        },
        
        submitPiaaForm(e) {
            e.preventDefault();
            if (!this.validatePiaaForm()) {
                // Display an error message or show a validation error
                alert("Please fill in all fields.");
                return;
            }
            // Logic to submit the form data
            this.submissionUtils(this.piaaData);
            alert("PIAA Form submitted successfully!");
            // Reset form fields after submission
            this.piaaData = {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",                
                sex: "",
                ghana_card: "", 
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "PIAA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application", 
                session_id: "", 
                created_at: new Date(),
            }
        },

        submitBiaForm(e) {
            e.preventDefault();
            if (!this.validateBiaForm()) {
                // Display an error message or show a validation error
                alert("Please fill in all fields.");
                return;
            }
            // Logic to submit the form data
            this.submissionUtils(this.biaData);
            alert("BIA Form submitted successfully!");
            // Reset form fields after submission
            this.biaData = {
                client_name: "",
                client_phone: "",
                client_location: "",
                region: "",
                district: "",
                community: "",
                age: "",                
                sex: "",
                ghana_card: "", 
                category: {
                    item: "",
                },
                product: {
                    item: "",   
                },
                project: "PIAA",
                confirmed: "",
                is_lma: null,
                remarks: "New Application", 
                session_id: "", 
                created_at: new Date(),
            }
        },
        
        submissionUtils(item) {
            const dataToSubmit = {
                client_name: item.client_name,
                client_phone: item.client_phone.replace("+", "").replace(/^0/, '233').replaceAll(" ", ""),
                client_location: item.client_location,
                region: item.region,
                district: item.district,
                community: item.community,
                sex: item.sex,
                age: item.age,
                ghana_card: item.ghana_card,
                category: item.category.item,
                product: item.product.item,
                project: item.project,
                confirm: item.confirmed,
                completed: false,
                is_lma: null,
                remarks: "New Application",
                source: "Website",
                service: {
                        acceptDetails: true,
                        enabled: true,
                        id: "omLbBioUs9mtKcRFe7vD",
                        index: "2",
                        name: "Register AkokoSika"
                    },
                session_id: item.session_id || "",
                created_at: new Date(),
            };
            // console.log(dataToSubmit, "-------data to submit");

            setDoc(doc(db, "requests", `${dataToSubmit.client_name}, ${new Date().getDate()}`), dataToSubmit)
        }
    }
}
</script>

<style scoped>
span {
    display: block;
    font-size: 16px;
    font-weight: 400;
    color: #3db49d;
}

.Projects .project-nav-tabs {
    border: 0;
}

.Projects .nav-link {
    height: 80%;
    width:  auto;
    border: 2px solid #d4d6df;
    padding: 15px;
    transition: 0.3s;
    color: #2a2c39;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Projects .nav-link i {
    padding-right: 15px;
    font-size: 48px;
}

.Projects .nav-link h4 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.Projects .nav-link:hover {
    color: #3db49d;
    border: 2px solid #3db49d;
}

.Projects .nav-link.active {
    background: #fff;
    color: #3db49d;
    border-color: #3db49d;
}

.btn-visit {

    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    text-decoration: none;
    display: inline-block;
    padding: 14px 32px;
    border-radius: 5px;
    transition: 0.3s;
    line-height: 1;
    color: #3db49d;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    margin-top: 6px;
    height: 48px;
    width: auto;
    border: 2px solid #3db49d;
}

.btn-form {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    text-decoration: none;
    display: inline-block;
    padding: 14px 32px;
    border-radius: 5px;
    transition: 0.3s;
    line-height: 1;
    color: #fff;
    background-color: #3db49d;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    margin-top: 6px;
    height: 48px;
    width: auto;
    border: 2px solid #3db49d;
}

.btn-download {
    text-decoration: none;
    display: inline-block;
    border-radius: 5px;
    margin-top: 6px;
    margin-left: 10px;
    height: 53px;
    width: auto;
}

.btn-visit:hover {
    background: #3db49d;
    color: #fff;
    text-decoration: none;
}

@media (max-width: 768px) {
    .Projects .nav-link i {
        padding: 0;
        line-height: 1;
        font-size: 36px;
    }
}

@media (max-width: 575px) {
    .Projects .nav-link {
        padding: 15px;
    }

    .Projects .nav-link i {
        font-size: 24px;
    }

}

@media (max-width: 375px) {
    .product-logo {
        max-width: 180%;
        height: auto;
    }
}

.Projects .tab-content {
    margin-top: 30px;
}

.Projects .tab-pane h3 {
    font-weight: 600;
    font-size: 26px;
}

.Projects .tab-pane ul {
    list-style: none;
    padding: 0;
}

.Projects .tab-pane ul li {
    padding-bottom: 0px;
}

.Projects .tab-pane ul i {
    font-size: 20px;
    padding-right: 4px;
    color: #3db49d;
}

.Projects .tab-pane p:last-child {
    margin-bottom: 0;
}
</style>